<template>
  <div>
    <nav class="level app-levelbar"
        style="padding: 4px;">
      <div class="level-left">
        <div class="level-item">
          <span class="level-title is-5">
            <strong class="flex-align" v-if="curMenu">{{ computedMenuName }}
              <link-icon class="flex-align" :link="curMenu.link" v-if="curMenu.link"></link-icon>
              <clipboard-btn2 :clipboard="curMenu.clipboard" v-if="curMenu.clipboard"></clipboard-btn2>
            </strong>
          </span>
        </div>
        <div v-if="curMenu" style="white-space: pre-line">{{ computedMenuDesc }}</div>
      </div>
      <div class="level-right is-hidden-mobile">
        <div>
          <div v-if="depth.length>0&&depth[0].menu_id==='dashboard'"
              style="text-align:right;color:#989898;margin-bottom:8px">ver. {{ $store.getters.getServiceSetting.version_office }}</div>
          <ol class="breadcrumb" v-if="!reviseState">
            <li class="home" v-if="curMenu">홈</li>
            <li v-for="(m, i) in depth" :key="'li-'+i">
              <span v-if="m" :class="{'is-active': i === depth.length-1}">
                <span v-if="i === depth.length-2" class="link-item" @click="linkClick(m)">
                  {{ m.name }}
                </span>
                <!-- 1뎁스 링크 줌 -->
                <span v-else-if="i === 0 && depth.length === 3" class="link-item" @click="linkClick(m)">
                  {{ m.name }}
                </span>
                <span v-else>
                  {{ m.name }}
                </span>
              </span>
            </li>
          </ol>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import LinkIcon from "./LinkIcon";
  import ClipboardBtn2 from "./ClipboardBtn2";
  export default {
    components: {ClipboardBtn2, LinkIcon},
    props: {
      prod: {
        type: Object
      }
    },
    data() {
      return {
        menus: [],
        curMenu: {},
        depth: [],
        reviseState: false,
        tab1: {
          booking: {
            label: '예약 일정/가격',
            desc: '상품의 예약 일정/가격을 설정합니다.'
          },
          reservation: {
            label: '일정',
            desc: '상품의 예약 일정을 설정합니다.'
          }
        }
      }
    },
    created() {
      this.reviseState = false;
      setTimeout(res=>{
        this.setMenu();
      },500)
    },
    watch: {
      '$route'() {
        this.reviseState = false;
      },
      '$route.path'(n) {
        this.setMenu();
      },
      '$route.hash'(n) {
        this.setMenu();
      },
      '$store.getters.prodTab'(n) {
        this.setMenu();
      },
      // 최초 로그인에서 대시보드 진입시 setMenu()호출시 메뉴가 없는 경우가 있어서
      // watch에 메뉴 걸어두고 메뉴 있을 경우 재호출
      '$store.state.menus'(n) {
        if(n) this.setMenu();
      }
    },
    computed: {
      prodTab() {
        return this.$store.getters.prodTab;
      },
      prodPackage() {
        return this.$store.getters.prodPackage;
      },
      computedMenuName() {
        let name = '';
        if (this.curMenu) {
          name = this.curMenu.name;
        }
        if (this.prodTab === 0) {
          if (this.$route.query.id && this.curMenu && this.curMenu.name && this.curMenu.name.indexOf('등록') > -1) {
            name = this.curMenu.name.replace('등록', '수정')
          } else {
            name = '상품 정보';
          }
        } else {
          name = this.tab1[this.prodPackage].label;
        }
        return name;
      },
      computedMenuDesc() {
        let desc = '';
        if (this.curMenu) {
          desc = this.curMenu.desc;
        }
        if (this.prodTab === 0) {
          if (this.$route.query.id && this.curMenu && this.curMenu.desc && this.curMenu.desc.indexOf('등록') > -1) {
            desc = this.curMenu.desc.replace('등록', '수정');
          } else {
            desc = '상품의 기본 정보를 등록합니다.';
          }
        } else {
          desc = this.tab1[this.prodPackage].desc;
        }
        return desc;
      },
    },
    methods: {
      saveData() {
        this.$emit('saveData');
      },
      linkClick(m) {
        let link = m.child[0].path;
        if (!link) {
          link = m.child[0].child[0].path;
        }
        this.$router.push(this.getPath(link))
      },
      setMenu() {
        this.menus = this.$store.getters.menus;
        let lower_path = '';
        if (this.$route.query.id) {
          let copy_path = this.$route.fullPath.toLowerCase();
          lower_path = copy_path.split('?')[0];
          lower_path = this.changePath(lower_path);
        }
        else {
          let copy_path = this.$route.fullPath.toLowerCase();
          lower_path = copy_path.split('#')[0];
          lower_path = this.changePath(lower_path);
        }
        this.depth = [];
        this.curMenu = this.bindMenu(this.menus, lower_path, 0)
        if(this.$route.query.id) {
          this.activeRevise();
        }
      },
      activeRevise() {
        this.reviseState = true;
      },
      bindMenu(data, path, d) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].child && data[i].child.length > 0) {
            let ret = this.bindMenu(data[i].child, path, d + 1)
            if (ret) {
              this.depth.splice(0, 0, data[i])
              return ret
            }

          } else {
            if (String(data[i].path).toLowerCase() === path) {
              this.depth.splice(0, 0, data[i])
              return data[i]
            }
          }
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .level-left
    display block

  .level-item
    justify-content flex-start

  .link-item
    color: #ff5722
    cursor: pointer

  .lp-title
    display flex
    justify-content space-between
    margin-bottom 16px

  .lp-page-title
    font-size 1.2rem

  .breadcrumb
    --separator "\2044"
    list-style none
    -ms-flex-align center
    align-items center
    display -ms-flexbox
    display flex
    -ms-flex-pack end
    justify-content flex-end

  .breadcrumb > li + li:before
    padding 0 5px
    color #ccc
    content var(--separator, "\2044")

  li
    display list-item
    text-align -webkit-match-parent

  .is-active
    color #393e46

  .level-title
    font-size 1.4rem

  .breadcrumb > .home
    color #ff5722

</style>
